import Highcharts from 'highcharts';

export const CHART_BASE_CONFIG = {
	title: {
	  	text: null
	},
	legend: {
		enabled: false
	},
	credits: {
		enabled: false
	}
};

export const BASE_PLOT_OPTIONS = {
    series: {
        animation: false,
        // enableMouseTracking: false, // enabled or disable mouse events (tooltip on hover)
        marker: {
            enabled: false
        },
    }
}

export const X_AXIS_BASE_CONFIG = {
    labels: {
        enabled: false
    },
    title: {
        text: null,
    },
    lineWidth: 0,
    minorTickLength: 0,
    tickLength: 0,
    startOnTick: false,
    endOnTick: false,
    minPadding: 0,
    maxPadding: 0,
};

export const Y_AXIS_BASE_CONFIG = {
    labels: {
        enabled: false
    },
    title: {
        text: null
    },
    startOnTick: false,
    endOnTick: false,
    gridLineWidth: 0,
    minorGridLineWidth : 0,
};

export function getColorGradient(color, left = true) {
    return {
        linearGradient: {
            x1: left ? 1 : 0,
            y1: 0,
            x2: left ? 0 : 1,
            y2: 0
        },
        stops : [
            [0, color],
            [0.7, color],
            [1, Highcharts.Color('#222').setOpacity(0).get('rgba')]
        ]
    };
}
